module.exports = __webpack_public_path__ + "img/0Q3A5610_L_Wood.b389dd95.jpg";